var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ loading: _vm.isLoading },attrs:{"id":"spinner"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader"})])])])
}]

export { render, staticRenderFns }